import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import ListItem from '../index';

export default class ListItemCompany extends PureComponent {
  render () {
    const { company } = this.props;

    return (
      <ListItem link={`companies/${company.id}`}>
        <div className={`py-1 col-9 col-sm-3 col-md-3 d-flex align-items-center align-self-stretch position-relative`}>
          <div>
            <div className='text-ellipsis text-md text-medium'>
              {company.company_name}
            </div>

            {company.is_individual && (
              <div className='list-item-label'>Private Party</div>
            )}
          </div>
        </div>
        <div className={`py-1 col-6 col-sm-3 col-md-3`}>
          <div className='text-capitalize'>{company.city}, {company.state} {company.zip}</div>
          <div className='list-item-label'>Address</div>
        </div>
        <div className={`py-1 col-9 col-sm-3 col-md-3`}>
          <div className='font-italic'>{company.owner_first_name} {company.owner_last_name} ({company.owner_email})</div>
          <div className='list-item-label'>Owner</div>
        </div>
        <div className={`py-1 pr-8 col-3 col-sm-2 col-md-3 d-flex justify-content-start justify-content-md-end `}>
          <div className='button button-badge button-primary'>
            {company.id}
          </div>
        </div>
      </ListItem>
    );
  }
}

ListItemCompany.propTypes = {
  company: PropTypes.object.isRequired
};



// WEBPACK FOOTER //
// ./src/components/common/lists/ListItem/ListItemCompany/index.js